import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { pageHead } from "@/lib/site";

export const Route = createFileRoute("/")({
  head: () =>
    pageHead(
      "Reliable Land Clearing & Property Services in Highland, UT",
      "Dumpster rental, land clearing, weed control, spring and fall cleanup, and snow removal in Highland, Utah. Call Scotty's for a quote.",
      "/",
    ),
  component: Index,
});
